import { render, staticRenderFns } from "./YoutubePlaylist.vue?vue&type=template&id=148c95e7&scoped=true&"
import script from "./YoutubePlaylist.vue?vue&type=script&lang=ts&"
export * from "./YoutubePlaylist.vue?vue&type=script&lang=ts&"
import style0 from "./YoutubePlaylist.vue?vue&type=style&index=0&id=148c95e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148c95e7",
  null
  
)

export default component.exports